import React from 'react';

type ImageProps = {
    name: string;
    hint?: string;
    className?: string;
    onClick?: ()=>void;
}
export default function Image({name, hint, className, onClick}: ImageProps) {
    const src = name ? `img/${name}.png` : undefined;
    return <img onClick={onClick} className={className} src={src} title={hint} draggable="false"/>
}
